import { gql } from "@apollo/client";

export const GET_APPOINTMENTS = gql`
  query getAppointments {
    getAppointments {
      past {
        year,
        appointmentsByMonth {
          month,
          appointments {
            id,
            active,
            start_at,
            end_at,
            duration,
            status,
            description,
            promoCode,
            destination_address,
            pet {
              id,
              name,
              image,
              speciesName,
              breedName,
              species,
              breed,
              gender,
            },
            tasks {
              description,
              type,
            },
            reasonsForVisit,
            appointmentType,
            allowedToEdit,
            appointmentCreateType,
            location {
              idLocation,
              locationName,
              address,
              city,
              background,
              position {
                lat,
                lng,
              },
              email,
              phoneNumber,
              timeZone,
            },
          }
        },
      },
      upcoming {
        date,
        appointments {
          id,
          active,
          start_at,
          end_at,
          duration,
          status,
          description,
          promoCode,
          destination_address,
          pet {
            id,
              name,
              image,
              speciesName,
              breedName,
              species,
              breed,
              gender,
          },
          tasks {
            description,
            type,
          },
          reasonsForVisit,
          appointmentType,
          allowedToEdit,
          appointmentCreateType,
          location {
            idLocation,
            locationName,
            address,
            city,
            background,
            position {
              lat,
              lng,
            },
            email,
            phoneNumber,
            timeZone,
          },
        },
      },
      messages,
    }
  }
`;
